import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";

export const citizenServicesCategoryField =`
id
diagramUniqueId
procedureDiagram
`;



export const GET_CITIZEN_SERVICES_DELIVERY_DIAGRAM = gql`
query CitizenGetServicesDeliveryProcedureDiagram($serviceUniqueId:String){
    citizenGetServicesDeliveryProcedureDiagram(serviceUniqueId:$serviceUniqueId){
    ${baseResponseGraphqlField}
    data {
      ${citizenServicesCategoryField}
    }
  }
}
`
;
